import React from 'react';
import './LoanSummaryTable.scss';
import InformationSVG from '../../../assets/images/information-icon.svg';
import { InfoTooltip } from 'components/tooltip/tooltip';

import { formatText, HtmlText } from 'core/i18n';

class LoanSummaryTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { amount, frequency, tin, tae, openingFee, totalAmount, monthlyFee, totalCost } = this.props;
        return (
            <div className="loan-summary-table">
                <div className="loan-summary-table__heading">
                    <p>{HtmlText(formatText('standbyLoan-title2_ares', [amount, frequency]))}</p>
                </div>
                <div className="loan-summary-table__cell">
                    <div className="loan-summary-table__content">
                        <h3>{HtmlText(formatText('standbyLoan-item1_ares'))}</h3>
                        <p>{tin}%</p>
                    </div>
                </div>
                <div className="loan-summary-table__cell">
                    <div className="loan-summary-table__content">
                        <h3>{HtmlText(formatText('standbyLoan-item2_ares'))}</h3>
                        <p className="bold">{tae}%</p>
                    </div>
                </div>
                <div className="loan-summary-table__cell">
                    <div className="loan-summary-table__content">
                        <h3>{HtmlText(formatText('standbyLoan-item3_ares'))}</h3>
                        <p>{openingFee}€</p>
                    </div>
                </div>
                <div className="loan-summary-table__cell">
                    <div className="loan-summary-table__content">
                        <h3>
                            {HtmlText(formatText('standbyLoan-item4_ares'))}
                            <InfoTooltip
                                icon={InformationSVG}
                                text={formatText('standbyLoan-tooltip_ares', [totalCost])}
                            />
                        </h3>
                        <p>{totalAmount}€</p>
                    </div>
                </div>
                <div className="loan-summary-table__cell">
                    <div className="loan-summary-table__content">
                        <h3>{HtmlText(formatText('standbyLoan-item5_ares'))}</h3>
                        <p className="big">{monthlyFee}€</p>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = LoanSummaryTable;
